export default "__VITE_ASSET__04be155f__"